import { numFormat, roundNum } from '../../com/dataUtil';
import './monitorUserStatInfo.css';
import styles from './monitorUserStat.module.css';

// 유저 정보 테이블 컴포넌트
const MonitorUserStatInfo = ({dataItem}) => {

  // 유저 설비 상태에 따른 색깔 처리
  let status = ' BgcolorG';
  if(dataItem.meainStatCode === 20001){
    status = ' BgcolorG';
  }
  else if(dataItem.meainStatCode === 20003){
    status = ' BgcolorGry';
  }
  else if(dataItem.meainStatCode === 20002){
    status = ' BgcolorY';
  }
  else if(dataItem.meainStatCode === 20004){
    status = ' BgcolorR';
  }

  // 마우스 오버
  // const mounseOverEvt = (e) =>{
  //   console.log("마우스 오버 = ", dataItem);
  // }

  // // 마우스 아웃
  // const mounseOutEvt = (e) =>{
  //   console.log("마우스 오버");
  // }

  return(
    <>
      <table className="DAFourDBG">
        <tr>
            <td>
                <div className={['DAFourD' , status ].join('')} 
                // onMouseOver = {mounseOverEvt}  
                >
                    <div className={styles.DAFourN}>{dataItem.nickName}</div>
                    {/* <div><span>{dataItem.userAge}</span>세</div> */}
                </div>
            </td>
            <td>
                <table className="DAFourCon">
                    <tr>
                        <th>
                            <img src="/images/chncareimg/icon_01.png" alt="호흡"/>
                        </th>
                        <td>
                            호&nbsp;&nbsp;&nbsp;&nbsp;흡
                        </td>
                        <td>
                          {dataItem.respiratoryRate !== null ? dataItem.respiratoryRate : '-'}
                        </td>
                        <td>
                            BPM
                        </td>
                    </tr>
                    <tr>
                        <th>
                            <img src="/images/chncareimg/icon_03.png" alt="움직임"/>
                        </th>
                        <td>
                            움직임
                        </td>
                        <td>
                          {dataItem.movement !== null ? numFormat(dataItem.movement) : '-'}
                        </td>
                        <td>
                            
                        </td>
                    </tr>
                </table>
            </td>
            <td>
                <table className="DAFourCon">
                    <tr>
                        <th>
                            <img src="/images/chncareimg/icon_02.png" alt="온도"/>
                        </th>
                        <td>
                            온&nbsp;&nbsp;&nbsp;&nbsp;도
                        </td>
                        <td>
                          {dataItem.temperature !== null ? roundNum(dataItem.temperature,2) : '-'}
                        </td>
                        <td>
                            ℃
                        </td>
                    </tr>
                    <tr>
                        <th>
                            <img src="/images/chncareimg/icon_04.png" alt="습도"/>
                        </th>
                        <td>
                            습&nbsp;&nbsp;&nbsp;&nbsp;도
                        </td>
                        <td>
                          {dataItem.humidity !== null ? roundNum(dataItem.humidity,2) : '-'}
                        </td>
                        <td>
                            %
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
  </>
  )
}

export default MonitorUserStatInfo;